import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ number, label, title, sub, dark = false }) {
  return (
    <div className="mb-14 sm:mb-20">
      <Reveal>
        <div className="flex items-baseline gap-4 mb-6">
          <span className={`text-xs font-semibold tracking-[0.25em] ${dark ? "text-neutral-500" : "text-neutral-400"}`}>
            {number}
          </span>
          <span className={`text-xs uppercase tracking-[0.25em] font-semibold ${dark ? "text-neutral-400" : "text-neutral-500"}`}>
            {label}
          </span>
          <span className={`flex-1 h-px ${dark ? "bg-neutral-800" : "bg-neutral-200"}`} />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className={`text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium max-w-3xl ${dark ? "text-white" : "text-neutral-950"}`}>
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.2}>
          <p className={`mt-6 max-w-2xl text-base sm:text-lg leading-relaxed ${dark ? "text-neutral-400" : "text-neutral-600"}`}>
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
